// The public forms in v2 sections (Get a quote, newsletter, contact): the
// same protection as today's contact form — a one-time token fetched when the
// form appears, a honeypot field, the server's 8-second minimum and Origin
// check (src/server/api/contact.js). In the studio preview nothing is sent.
import axios from "axios";
import {onMounted, ref} from "vue";

export function isPreviewSite() {
    if (typeof window !== "undefined") return import.meta.env.VITE_IS_PREVIEW_SERVER === "true";
    return process.env.IS_PREVIEW_SERVER === "true";
}

export function useFormPost() {
    const token = ref("");
    const honeypot = ref("");
    const sending = ref(false);
    const sent = ref(false);
    const error = ref("");
    const preview = isPreviewSite();

    onMounted(async () => {
        if (preview) return;
        try {
            const r = await axios.get("/api/contact/generate-token");
            token.value = r.data.token;
        } catch (e) {
            // The submit says so if it fails.
        }
    });

    async function post(path, body) {
        error.value = "";
        if (preview) {
            sent.value = true;
            return true;
        }
        sending.value = true;
        try {
            await axios.post(`/api/contact/${path}`, {...body, token: token.value, businessName: honeypot.value});
            sent.value = true;
            return true;
        } catch (e) {
            const status = e?.response?.status;
            error.value = status === 429 ? "Too many tries. Please wait a minute and try again."
                : (e?.response?.data?.error && status === 400 && e.response.data.field ? e.response.data.error
                    : "That didn't send. Please try again, or call us.");
            return false;
        } finally {
            sending.value = false;
        }
    }

    return {token, honeypot, sending, sent, error, preview, post};
}
